import React, { FC, useState } from 'react';
import { AxiosError } from 'axios';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

import { AxiosInstance } from '../utils/api';

interface FileDownloadButtonProps extends ButtonProps {
  url: string;
  label?: string;
  downloadingLabel?: string;
  fileName?: string;
}

const FileDownloadButton: FC<FileDownloadButtonProps> = ({
  url,
  label = 'download',
  downloadingLabel = 'downloading',
  startIcon = <CircularProgress size={10} color="inherit" />,
  ...props
}) => {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState<AxiosError<{ message: string }> & any>();
  const handleDownload = e => {
    const run = async () => {
      setDownloading(true);

      await AxiosInstance({
        method: 'GET',
        url,
        responseType: 'blob',
        timeout: null,
      })
        .then(response => {
          const blob = new Blob([response.data], { type: response.data.type });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'unknown';

          if (props.fileName) {
            fileName = props.fileName;
          } else {
            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
              if (fileNameMatch?.length === 2) fileName = fileNameMatch[1];
            }
          }

          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(err => setError(err))
        .finally(() => setDownloading(false));
    };

    run();
  };

  if (error) return <div>{error?.message}</div>;

  return (
    <Button
      disabled={downloading}
      onClick={handleDownload}
      startIcon={downloading ? startIcon : null}
      {...props}
    >
      {downloading ? downloadingLabel : label}
    </Button>
  );
};

export default FileDownloadButton;
